import React from 'react';
import './HowItWorks.css';
import prescrip from "../../images/prescrip.jpg";
import phone from "../../images/phone.jpg";
import delivery from "../../images/delivery.jpg";
import { Link } from 'react-router-dom';

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitl">Get your medications in just 3 simple steps</p>
        </div>

        <div className="steps-container">
          {/* Step 1 */}
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-content">
              <div className="step-image-container">
                <img 
                  src={prescrip} 
                  alt="Prescription" 
                  className="step-image"
                />
                <div className="step-overlay">
                  <Link to='/prescription'><button className="step-button">Upload Prescription</button></Link>
                </div>
              </div>
              <div className="step-text">
                <h3 className="step-title">Add Your Prescription</h3>
                <p className="step-description">
                  Transfer your existing prescription by providing the Rx number, pharmacy name, and phone number. We'll handle the rest seamlessly.
                </p>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-content">
              <div className="step-image-container">
                <img 
                  src={phone}
                  alt="Mobile payment" 
                  className="step-image"
                />
                <div className="step-overlay">
                 
                </div>
              </div>
              <div className="step-text">
                <h3 className="step-title">Place Your Order</h3>
                <p className="step-description">
                  Consult with our pharmacist about medication availability and complete your purchase with secure online payment options.
                </p>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-content">
              <div className="step-image-container">
                <img 
                  src={delivery}
                  alt="Package delivery" 
                  className="step-image"
                />
                <div className="step-overlay">
                 
                </div>
              </div>
              <div className="step-text">
                <h3 className="step-title">Fast, Discreet Delivery</h3>
                <p className="step-description">
                  Receive your medications in secure, discreet packaging within 3-4 days, delivered right to your doorstep.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;